"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    if (!await knex.schema.hasColumn(_globals.MetaTableOldV2.BASES, 'erd_uuid')) {
        await knex.schema.alterTable(_globals.MetaTableOldV2.BASES, (table)=>{
            table.string('erd_uuid');
        });
    }
    if (!await knex.schema.hasTable(_globals.MetaTable.NOTIFICATION)) {
        await knex.schema.createTable(_globals.MetaTable.NOTIFICATION, (table)=>{
            table.string('id', 20).primary().notNullable();
            table.string('type', 40);
            table.text('body');
            table.boolean('is_read').defaultTo(false);
            table.boolean('is_deleted').defaultTo(false);
            table.string('fk_user_id', 20).index();
            table.timestamps(true, true);
            table.index('created_at');
        });
    }
    await knex.schema.alterTable(_globals.MetaTable.FILTER_EXP, (table)=>{
        table.text('value').alter();
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTableOldV2.BASES, (table)=>{
        table.dropColumn('erd_uuid');
    });
    knex.schema.dropTable(_globals.MetaTable.NOTIFICATION);
    await knex.schema.alterTable(_globals.MetaTable.FILTER_EXP, (table)=>{
        table.string('value', 255).alter();
    });
};
